import { finalize, Observable, OperatorFunction } from 'rxjs';
import { decrementRequest, incrementRequest } from '../../../interceptor/peticion-api.interceptor';

export function withSpinner<T>(): OperatorFunction<T, T> {
  return (source: Observable<T>) => {
    incrementRequest()
    return source.pipe(
      finalize(() => {
        decrementRequest()
      })
    )
  }
}